

import { CLAIMENT_DETAILS_SET_VALUE } from "../../../actions/sizotsaFuneralClaim/claimentDetails";
import { DECEASED_DETAILS_SET_VALUE } from "../../../actions/sizotsaFuneralClaim/deceasedDetails";
import { SZ_CLAIM_UPLOAD_DOCUMENT} from "../../../actions/sizotsaFuneralClaim/uploadDocuments";
import { claimentDetailsValidation } from "./claimentDetails";
import { deceasedDetailsValidation } from "./deceasedDetails";
import { uploadDocumentsValidation } from "./uploadDocuments";

export const sizotsaFuneralClaimValidations = (store, next, action) => {

//   if (action.type.startsWith(PAYMENT_DETAILS_SET_VALUE)){
//       return paymentDetailsValidation(store, next, action);}
if (action.type.startsWith(SZ_CLAIM_UPLOAD_DOCUMENT)) {
  return uploadDocumentsValidation(store, next, action);
}
  if (action.type.startsWith(CLAIMENT_DETAILS_SET_VALUE)) {

    return claimentDetailsValidation(store, next, action);
  }
  if (action.type.startsWith(DECEASED_DETAILS_SET_VALUE)) {

    return deceasedDetailsValidation(store, next, action);
  }
  
  return null;
};
